import { render, staticRenderFns } from "./skuToTon.vue?vue&type=template&id=99bff956&scoped=true&"
import script from "./skuToTon.vue?vue&type=script&lang=js&"
export * from "./skuToTon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bff956",
  null
  
)

export default component.exports